export default __webpack_public_path__ + "media/images/act-a8df50af7d344336904103671bfa8c7e.png";